import React from "react";
import "./ai-conversations-card.scss";
import { DUMMY_RESPONDENTS } from "./dummyXrayChatData";

const getInitials = (respondent) =>
  `${respondent.firstName?.[0] || ""}${respondent.lastName?.[0] || ""}`.toUpperCase();

// `onViewConversation` is called with the respondent when "View" is clicked.
// The caller decides how to actually show the chat (currently: open it in a
// new tab). Kept as a prop so this component doesn't care about that detail.
export const AiConversationsCard = ({
  respondents = DUMMY_RESPONDENTS,
  onViewConversation = () => {},
  // The header dropdown (StatsCard's nav bar) already shows the "AI
  // Conversations" label + count on the trigger button itself, so the
  // list rendered inside that dropdown skips this component's own header
  // row to avoid showing the same title/badge twice.
  showHeader = true,
}) => {
  // Scenario 4 (deactivated + never chatted) has nothing worth showing —
  // no chat to view, and the person isn't even active anymore. Drop it
  // before it ever reaches the list.
  const visibleRespondents = respondents.filter(
    (r) => r.isActive || r.chatMessageCount > 0
  );

  const activeChatted = visibleRespondents.filter(
    (r) => r.isActive && r.chatMessageCount > 0
  );
  const deactivatedChatted = visibleRespondents.filter(
    (r) => !r.isActive && r.chatMessageCount > 0
  );
  const activeNoChat = visibleRespondents.filter(
    (r) => r.isActive && r.chatMessageCount === 0
  );

  // Order: anyone with a chat to view first (active, then deactivated), then
  // active respondents who haven't chatted at all, always last.
  const orderedRespondents = [
    ...activeChatted,
    ...deactivatedChatted,
    ...activeNoChat,
  ];

  const chattedCount = activeChatted.length + deactivatedChatted.length;

  return (
    <div className={`ai-conversations-card${showHeader ? "" : " no-header"}`}>
      {showHeader ? (
        <div className="d-flex align-items-center justify-content-between header-row">
          <div className="title">AI Conversations</div>
          <div className="count-badge">
            {chattedCount} of {visibleRespondents.length} chatted
          </div>
        </div>
      ) : null}
      <div className="respondent-list">
        {orderedRespondents.map((respondent) => {
          const chatted = respondent.chatMessageCount > 0;
          return (
            <div
              className={`respondent-row d-flex align-items-center ${chatted ? "" : "no-chat"
                }`}
              key={respondent.userId}
            >
              <div
                className={`initials-avatar ${!respondent.isActive ? "deactivated" : ""
                  }`}
              >
                {getInitials(respondent)}
              </div>
              <div className="row-text flex-grow-1">
                <div className="name">
                  {respondent.firstName} {respondent.lastName}
                  {!respondent.isActive ? (
                    <span className="deactivated-tag">Deactivated</span>
                  ) : null}
                </div>
                <div className="subtext">
                  {chatted
                    ? `${respondent.chatMessageCount} msgs, last active ${respondent.lastActiveLabel}`
                    : "no conversation yet"}
                </div>
              </div>
              {chatted ? (
                <button
                  type="button"
                  className="view-chat-btn d-flex align-items-center"
                  onClick={() => onViewConversation(respondent)}
                >
                  <i className="fa-regular fa-comment"></i>
                  <span>View</span>
                </button>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AiConversationsCard;
